<template>
    <div>        
        <div class="row">   

            <div style="width: 70%;">
                <div class="col-xs-12 col-md-12 offset-md-2 block">
                    <div class="wrapper-progressBar">
                        <ul class="progressBar">
                            <li class="active">Añade Tu Plataforma</li>
                            <li class="active">Añade Tus Canales</li>
                            <li>Selecciona un Video</li>
                            <li>¡Genera Tus Ideas!</li>
                        </ul>
                    </div>
                </div>
            </div>
                    
            <div class="jumbotron bg-light" style="width: 100%; margin-top: 10px;">
                <router-link to="/plataformas" style="margin-top: -60px;" class="btn btn-outline-dark"><span class="mdi mdi-keyboard-return"></span> Regresar a Plataformas</router-link>
                <br><br>
                <h1 style="margin-top: -35px;" class="display-6" v-if="canales.length <= 0"> <b-skeleton v-if="estado_peticion"></b-skeleton> <p v-else>¡Añade Tu Canal!</p></h1>
                <h1 style="margin-top: -35px;" class="display-6" v-else>¡Selecciona tu Canal!</h1>

                <b-card sub-title="Escribe el usuario">
                    <form>
                        <div class="row">
                            <div class="col-sm-8">                  
                                <input type="text" v-model="url_plataforma.url" class="form-control" required>
                            </div> 
                            <div class="col-sm-4">
                                
                                <b-button variant="outline-dark" type="submit" @click.prevent="saveUrlPlataforma"><span class="mdi mdi-plus-circle-outline"></span> Añadir Canal</b-button>
                                
                            </div>                                        
                        </div>
                    </form>
                </b-card>  
                <br>               
                <p class="lead" v-if="canales.length <= 0">
                    <b-alert show variant="warning">
                        <b-skeleton animation="wave" width="85%" v-if="estado_peticion"></b-skeleton>
                        <b-skeleton animation="wave" width="55%" v-if="estado_peticion"></b-skeleton>
                        <b-skeleton animation="wave" width="70%" v-if="estado_peticion"></b-skeleton>
                        <p v-else>Añade tu canal primero para ver el listado de tus videos.</p>
                    </b-alert>
                </p>
                <p v-else style="font-weight: bold;">
                    <b-alert show variant="primary">Selecciona tu canal para ver el listado de tus videos.</b-alert>
                </p>                           
                <br>           
                <div>

                    <div  v-if="canales.length > 0" class="row">
                        <div class="col-md-3 mb-3" v-for="canal in canales" v-bind:key="canal" >
                            <div class="card" style="align-items: center;">
                                <div class="card-body" style="cursor: pointer;" @click="navegacion('listado_post', canal.url)">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/512px-YouTube_full-color_icon_%282017%29.svg.png?20240107144800" alt="Youtube" width="40" height="30">&nbsp; {{ canal.url }}
                                </div>
                            </div>
                        </div>                            
                    </div>
                    <div class="card" v-else>
                        <div class="card-body">
                            Aún no has agregado un Canal :(!
                        </div>
                    </div>                    

                </div>

            </div>  
            
        </div>        
    </div>
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        canales: [],
        url_plataforma: {
            url: '',
            id_usuario_plataforma: ''
        },
        estado_peticion: true,
    }), 
    mounted() {
        this.getUrlPlataforma()
    },
    methods: {
        async getUrlPlataforma() {

            return await this.axios.get(configApi+'url_plataforma', {headers})
            .then(response => {
                this.canales = response.data.data;
                this.loading = false 
            })

        },       
        async saveUrlPlataforma() {

            this.url_plataforma.id_usuario_plataforma = localStorage.getItem('id_usuario_plataforma')

            console.log(this.url_plataforma)

            return await this.axios.post(configApi+'url_plataforma', this.url_plataforma,{headers})
            .then(response => {
                this.$bvModal.hide('crearUrlPlataforma')  
                // this.resetForm()                 
                this.getUrlPlataforma()                

                if(response.data.data.id > 0) {
                    this.$Fun.alertaAccion('success', response.data.message, false)
                } else {
                    this.$Fun.alertaAccion('warning', response.data.message, false)
                }

            })
        },
        navegacion(menu, usuario) {
            this.$router.push('/'+menu+'/'+usuario)
        },
    }
}
</script>
<style>
.wrapper-progressBar {
    width: 100%;
}

.progressBar li {
    list-style-type: none;
    float: left;
    width: 25%;
    position: relative;
    text-align: center;
}

.progressBar li:before {
    content: " ";
    line-height: 30px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px;
    background-color: white
}

.progressBar li:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: #ddd;
    top: 15px;
    left: -50%;
    z-index: -1;
}

.progressBar li:first-child:after {
    content: none;
}

.progressBar li.active {
    color: dodgerblue;
}

.progressBar li.active:before {
    border-color: dodgerblue;
    background-color: dodgerblue
}

.progressBar .active:after {
    background-color: dodgerblue;
}
</style>